import { Transforms } from "slate";

export async function insertEmbedFromUrl(editor, url) {
  if (!editor.selection) return false;

  const youTubeEmbedUrl = getYouTubeEmbedUrl(url);

  const insertNode = (node) => {
    Transforms.insertNodes(editor, node);
    // Optional: insert a blank paragraph after for UX
    Transforms.insertNodes(editor, {
      type: "paragraph",
      children: [{ text: "" }]
    });
  };

  if (youTubeEmbedUrl) {
    insertNode({
      type: "embed",
      url: youTubeEmbedUrl,
      width: 500,
      height: 280,
      align: "left",
      children: [{ text: "" }]
    });
    return true;
  }

  if (isIframable(url)) {
    insertNode({
      type: "embed",
      url,
      width: "100%",
      height: 300,
      align: "left",
      children: [{ text: "" }]
    });
    return true;
  }

  const linkPreview = await fetchLinkPreview(url);
  if (linkPreview) {
    insertNode({
      type: "link-preview",
      url,
      title: linkPreview.title,
      description: linkPreview.description,
      image: linkPreview.image,
      children: [{ text: "" }]
    });
    return true;
  }

  return false;
}

function getYouTubeEmbedUrl(url) {
  try {
    const parsed = new URL(url);
    if (parsed.hostname.includes("youtube.com") && parsed.searchParams.has("v")) {
      const videoId = parsed.searchParams.get("v");
      return `https://www.youtube.com/embed/${videoId}`;
    }
    if (parsed.hostname === "youtu.be") {
      const videoId = parsed.pathname.split("/")[1];
      return `https://www.youtube.com/embed/${videoId}`;
    }
  } catch (e) {
    console.warn("Invalid YouTube URL", e);
  }
  return null;
}

function isIframable(url) {
  const patterns = [
    "vimeo.com",
    "player.vimeo.com",
    "figma.com/embed",
    "spotify.com",
    "soundcloud.com",
    "google.com/maps/embed",
    "twitter.com",
    "codesandbox.io/embed",
    "codepen.io"
  ];
  return patterns.some(pattern => url.includes(pattern));
}

async function fetchLinkPreview(url) {
  try {
    const res = await fetch(`https://api.linkpreview.net/?key=263822fbad75ae540d702bd3f5263878&q=${encodeURIComponent(url)}`);
    const data = await res.json();
    if (data?.title) {
      return {
        title: data.title,
        description: data.description,
        image: data.image
      };
    }
  } catch (error) {
    console.warn("Link preview fetch failed", error);
  }
  return null;
}
